import styled, {
  createGlobalStyle,
} from 'styled-components';
import './typography.css';

export const GlobalStyles = createGlobalStyle`
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px rgba(24, 24, 40, 1) inset !important;
    -webkit-text-fill-color:  #fff;
    border:1px solid #444454;
  }

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body{
    background: rgba(24, 24, 40, 1);
    font-family: Georgia, 'Times New Roman', Times, serif;
    font-weight: normal;

    -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll; 
}
body::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
`;


export const Wrapper = styled.div`
  display: block;
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
`;

export const Container = styled.div`
  display: block;
  width: 90vw;
  margin: 0 auto;
  @media (min-width: 768px) {
    width: 80vw;
  }
`;
